"use client";

import { useState } from "react";
import viugoLeagueChevron from "@/assets/images/viugo/kbv-v16-league-chevron.svg";

export default function ViuGoMatchLeagues({
    league,
    matches,
    render = () => {},
}) {
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <div className="w-full">
            <div
                className="kbv-bg-league-row-indigo-slate flex md:w-full cursor-pointer select-none items-center gap-2 rounded-[8px] py-[6px] pr-[10px] text-[13px] font-medium capitalize text-white md:gap-0 md:pr-0"
                onClick={() => setIsExpanded((prev) => !prev)}
            >
                <div className="flex min-w-0 flex-1 items-center gap-2.5 pl-[10px] pr-2 md:basis-[28%] md:grow-0 md:shrink-0">
                    <div
                        className={`order-last ml-auto shrink-0 transition-transform duration-200 md:order-none md:ml-0 ${isExpanded ? "rotate-[270deg]" : "rotate-90"
                            }`}
                        aria-hidden
                    >
                        <img src={viugoLeagueChevron} alt="" width={10} height={10} className="h-2.5 w-2.5" aria-hidden />
                    </div>
                    {!!league?.logo && (
                        <img
                            className="h-5 w-7 shrink-0 object-contain"
                            src={league.logo}
                            alt={league?.name || "league"}
                            width="28"
                            height="20"
                            loading="lazy"
                        />
                    )}
                    <span className="min-w-0 flex-1 truncate text-[12px] leading-[15px]">
                        {league?.name}
                    </span>
                </div>

                <div className="hidden w-[35%] shrink-0 flex-row px-[3px] py-1 text-center text-[11px] font-medium sm:text-[13px] md:flex">
                    <span className="flex w-1/3 items-center justify-center">HDP</span>
                    <span className="flex w-1/3 items-center justify-center">O/U</span>
                    <span className="flex w-1/3 items-center justify-center">1X2</span>
                </div>
                <div className="hidden w-[35%] shrink-0 flex-row px-[3px] py-1 text-center text-[11px] font-medium sm:text-[13px] md:flex">
                    <span className="flex w-1/3 items-center justify-center">HDP H1</span>
                    <span className="flex w-1/3 items-center justify-center">O/U H1</span>
                    <span className="flex w-1/3 items-center justify-center">1X2 H1</span>
                </div>
            </div>

            {isExpanded && (
                <div className="flex flex-col w-full">
                    {matches?.map((match, index) => (
                        <div key={match.id}>
                            {render(match, index)}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

